const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Kantor Perusahaan",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Praktik Dokter Hewan",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Wajib",
    },
  },
  salutation: {
    label: "Sapaan",
    placeholder: "Pilih sapaan",
    errors: {
      required: "Sapaan wajib diisi",
      invalid: "Pilih sapaan yang valid",
    },
  },
  firstName: {
    label: "Nama depan",
    placeholder: "Budi",
    errors: {
      authenticatedNameUpdateTrial:
        "Anda sudah masuk dan nama Anda tidak dapat diubah.",
      required: "Nama depan wajib diisi",
      minLength: "Nama depan harus minimal 2 karakter",
      maxLength: "Nama depan harus maksimal 50 karakter",
    },
  },
  lastName: {
    label: "Nama belakang",
    placeholder: "Santoso",
    errors: {
      authenticatedNameUpdateTrial:
        "Anda sudah masuk dan nama Anda tidak dapat diubah.",
      required: "Nama belakang wajib diisi",
      minLength: "Nama belakang harus minimal 2 karakter",
      maxLength: "Nama belakang harus maksimal 50 karakter",
    },
  },
  email: {
    label: "Email",
    placeholder: "budi.santoso@example.com",
    description:
      "Masukkan alamat email pribadi Anda, bukan alamat email bersama.",
    prefixWarningTitle: "Kotak surat bersama terdeteksi",
    prefixWarningDescription:
      "Kami merekomendasikan menggunakan alamat email pribadi untuk pengalaman yang lebih baik dan personal",
    errors: {
      authenticatedEmailUpdateTrial:
        "Anda sudah masuk dan alamat email Anda tidak dapat diubah.",
      required: "Email wajib diisi",
      invalidEmail: "Masukkan alamat email yang valid",
      emailAssociatedWithYourAccount:
        "Alamat email Anda terkait dengan akun Anda dan tidak dapat diubah.",
    },
  },
  confirmEmail: {
    label: "Konfirmasi email",
    placeholder: "budi.santoso@example.com",
    errors: {
      authenticatedEmailUpdateTrial:
        "Anda sudah masuk dan alamat email Anda tidak dapat diubah.",
      required: "Konfirmasi email wajib diisi",
      invalidEmail: "Masukkan alamat email yang valid",
      emailMatchError: "Alamat email tidak cocok",
    },
  },
  password: {
    label: "Kata sandi",
    placeholder: "Masukkan kata sandi Anda",
    errors: {
      required: "Kata sandi wajib diisi",
    },
  },
  confirmPassword: {
    label: "Konfirmasi kata sandi",
    placeholder: "Konfirmasi kata sandisi",
    errors: {
      required: "Konfirmasi kata sandi wajib diisi",
      passwordMatchError: "Kata sandi tidak cocok",
    },
  },
  addressLine1: {
    label: "Baris alamat 1",
    placeholder: "Jalan Contoh 123",
    errors: {
      required: "Baris alamat 1 wajib diisi",
      minLength: "Baris alamat 1 harus minimal 5 karakter",
      maxLength: "Baris alamat 1 harus maksimal 100 karakter",
    },
  },
  addressLine2: {
    label: "Baris alamat 2",
    placeholder: "Apartemen 4B",
    errors: {
      required: "Baris alamat 2 wajib diisi",
      maxLength: "Baris alamat 2 harus maksimal 100 karakter",
    },
  },
  city: {
    label: "Kota",
    placeholder: "Jakarta",
    errors: {
      required: "Kota wajib diisi",
      minLength: "Kota harus minimal 2 karakter",
      maxLength: "Kota harus maksimal 50 karakter",
    },
  },
  country: {
    label: "Negara",
    placeholder: "Pilih Negara",
    errors: {
      required: "Negara wajib diisi",
      invalid: "Silakan pilih negara yang valid",
    },
  },
  state: {
    label: "Provinsi",
    placeholder: "Pilih provinsi",
    errors: {
      required: "Provinsi wajib diisi",
      invalid: "Pilih provinsi yang valid",
    },
  },
  jurisdiction: {
    label: "Yurisdiksi",
    placeholder: "Pilih yurisdiksi",
    errors: {
      required: "Yurisdiksi wajib diisi",
      invalid: "Pilih yurisdiksi yang valid",
    },
  },
  zipCode: {
    label: "Kode pos",
    placeholder: "10110",
    errors: {
      required: "Kode pos wajib diisi",
      invalid: "Masukkan kode pos yang valid",
    },
  },
  role: {
    label: "Peran",
    placeholder: "Pilih peran Anda",
    errors: {
      required: "Pilih peran Anda",
      invalid: "Pilih peran yang valid",
    },
  },
  businessType: {
    label: "Jenis Bisnis",
    placeholder: "Pilih jenis perusahaan",
    errors: {
      required: "Jenis Bisnis wajib diisi",
      invalid: "Pilih jenis perusahaan yang valid",
    },
  },
  businessName: {
    label: "Nama Perusahaan",
    placeholder: "Masukkan nama perusahaan",
    errors: {
      required: "Nama Perusahaan wajib diisi",
      minLength: "Nama perusahaan harus minimal 2 karakter",
      maxLength: "Nama perusahaan harus maksimal 100 karakter",
    },
  },
  businessSearch: {
    label: "Pencarian Perusahaan:",
    addNewAccount: "Tambahkan akun perusahaan baru",
    canNotFindBusiness: "Tidak menemukan perusahaan Anda?",
    guideline: "Masukkan kode pos Anda, kemudian pilih dari daftar di bawah.",
    guidelineForNameSearch:
      "Masukkan nama lengkap perusahaan, kemudian pilih dari daftar.",
    placeholder: "Di mana Anda bekerja?",
    noResults: "Tidak ada hasil ditemukan",
    searching: "Mencari...",
    selectedBusinessHeading: "Perusahaan yang dipilih:",
    selectedBusinessNotCorrect: "Tidak benar?",
    selectedBusinessTryAgain: "Coba lagi",
    selectedBusinessDismiss: "Tolak perusahaan",
    resultsFound: {
      singular: "1 perusahaan ditemukan",
      plural: "Beberapa perusahaan ditemukan",
    },
    errors: {
      network:
        "Ada masalah menghubungkan ke layanan pencarian perusahaan. Silakan coba lagi nanti.",
    },
  },
  explicitConsent: {
    label:
      "Dengan mencentang kotak ini, saya setuju untuk menerima komunikasi pemasaran dari Elanco.",
    errors: {
      required: "Persetujuan diperlukan",
    },
  },
  explicitSmsConsent: {
    label:
      "Dengan mencentang kotak ini, saya setuju untuk menerima komunikasi pemasaran dari Elanco melalui SMS/pesan teks.",
    errors: {
      required: "Persetujuan SMS diperlukan",
    },
  },
  telephone: {
    label: "Telepon pribadi",
    placeholder: "Masukkan nomor telepon pribadi Anda",
    dialCodeLabel: "Kode",
    dialCodePlaceholder: "Cari negara...",
    errors: {
      invalid: "Masukkan nomor telepon yang valid.",
    },
  },
  businessTelephone: {
    label: "Telepon Perusahaan",
    placeholder: "Masukkan nomor telepon perusahaan",
    dialCodeLabel: "Kode",
    dialCodePlaceholder: "Cari negara...",
    errors: {
      invalid: "Masukkan nomor telepon yang valid.",
    },
  },
  professionalNumber: {
    label: "Nomor Profesional",
    placeholder: "1234567",
    errors: {
      required: "Masukkan nomor profesional",
      maxLength: "Input melebihi batas karakter",
    },
  },
  addressSearch: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  businessSearchField: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  checkbox: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  combobox: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  datePicker: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  dateRange: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  dateTime: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  emailField: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  fileInput: {
    errors: {
      required: "Pilih file",
    },
  },
  number: {
    errors: {
      required: "Masukkan nomor",
      minValue: "Masukkan nilai yang lebih besar dari nilai minimum",
      maxValue: "Masukkan nilai yang lebih kecil dari nilai maksimum",
    },
  },
  passwordField: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  rangeSlider: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  select: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  telephoneField: {
    errors: {
      required: "Masukkan hanya angka",
      invalidTelephone: "Masukkan nomor telepon yang valid",
      invalidFormat: "Format nomor tidak valid",
    },
  },
  text: {
    errors: {
      required: "Gunakan hanya huruf (A-Z), angka (0-9), dan tanpa simbol",
      maxLength: "Input melebihi batas karakter",
      minLength: "Input harus minimal 2 karakter",
    },
  },
  textarea: {
    characters: "karakter",
  },
  time: {
    errors: {
      required: "Bidang ini wajib diisi",
    },
  },
  form: {
    errors: {
      generic: "Terjadi kesalahan saat mengirim formulir. Coba lagi.",
      reportAnIssue: "Laporkan masalah.",
      configuration: "Kesalahan konfigurasi",
      noFormQuestionsAvailable: "Item formulir tidak tersedia.",
      formComponentLoad:
        "Tidak dapat memuat komponen formulir karena bidang yang tidak didukung.",
      code: "Kode",
      type: "Tipe",
      missingRequiredFields:
        "Formulir kehilangan bidang wajib (Email dan/atau Persetujuan). Silakan hubungi administrator untuk memperbaiki konfigurasi formulir.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Kesejahteraan Hewan - Dokter Hewan",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Produsen - Campuran/Lainnya",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Pengecer",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Peternak Domba",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Dokter hewan",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Dokter hewan", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Dokter hewan, pemilik praktik",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Asisten dokter hewan",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Praktik Dokter Hewan - Lainnya",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Praktik Dokter Hewan - Dokter hewan",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Praktik Dokter Hewan - Perawat Hewan",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Spesialis Dokter Hewan",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Dokter hewan",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Tuan",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Tuan",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Nyonya",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Nyonya",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Profesor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
